import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  Subject,
  debounceTime,
  distinct,
  distinctUntilChanged,
  filter,
  map,
  takeUntil,
} from 'rxjs';

@Component({
  selector: 'app-tree-search',
  templateUrl: './tree-search.component.html',
})
export class TreeSearchComponent implements OnInit {
  @Input() searchString: string = '';

  /** Already translated by the caller - this component stays generic about what it searches. */
  @Input() placeholder: string = '';
  // output for search and reset
  @Output() search = new EventEmitter<string>();
  @Output() reset = new EventEmitter<void>();

  destroy$: Subject<void> = new Subject<void>();
  canSearch = false;
  canReset = false;

  constructor(private formBuilder: FormBuilder) {}
  ngOnInit(): void {
    this.registerChange();
    this.searchForm.setValue({ search: this.searchString });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  searchForm: FormGroup<SearchForm> = this.formBuilder.group({
    search: new FormControl(null),
  });

  onSubmit() {
    this.search.emit(this.searchForm.value.search);
  }

  registerChange() {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(300),
        map((value: { search: string | null }) => value.search?.trim()),
        filter((value) => value.length > 0 || value === null || value === ''),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      )
      .subscribe((value) => {
        this.canReset = value ? true : false;
        this.canSearch = value ? true : false;
        this.search.emit(this.searchForm.value.search);
      });
  }

  onReset() {
    this.searchForm.setValue({ search: '' });
    this.reset.emit();
    this.search.emit(this.searchForm.value.search);
  }
}

export class SearchForm {
  search: FormControl<string>;
}
